const API_URL = process.env.REACT_APP_API_URL;

export const fetchQuickLinksMapping = async (
  accessToken: string, 
  groupId?: number, 
  tenantID?: number
) => {
  try {
    // Prepare query parameters
    const params = new URLSearchParams();
    if (groupId) params.append("quickLinkGroupId", groupId.toString());
    if (tenantID) params.append("tenantID", tenantID.toString());

    // Construct API URL with query parameters
    let url = `${API_URL}${process.env.REACT_APP_QUICKLINK_GROUPS_GET_MAPPING}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    // Make the API call
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch quick links.");
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};


/**
 * Update quick links group mapping.
 * @param {string} accessToken - The user's access token.
 * @param {string} groupId - The group ID.
 * @param {Array<string>} selectedLinkDetails - An array of quick link IDs.
 * @param {number} tenantID - The tenant ID.
 * @returns {Promise<void>} - Resolves if successful.
 */
export const updateQuickLinksGroupMapping = async (
  accessToken: string, 
  groupId: number, 
  selectedLinkDetails: Array<string>, 
  tenantID: number
) => { 
  try {
    // Prepare query parameters
    const params = new URLSearchParams();
    params.append("quickLinksGroupId", groupId.toString()); // Append groupId
    params.append("tenantID", tenantID.toString()); // Append tenantID

    // Append all quickLinksId
    selectedLinkDetails.forEach((id) => params.append("quickLinksId", id.toString()));

    // Construct API URL with query parameters
    const apiUrl = `${API_URL}${process.env.REACT_APP_QUICKLINK_GROUPS_UPDATE_MAPPING}?${params.toString()}`;

    // Make the API call
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to update quick links group mapping.");
    }
  } catch (error) {
    throw error;
  }
};
